import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ListDescription.css';

interface IListDescriptionProps {
  list: string[];
}

export const ListDescription: React.FC<IListDescriptionProps> = ({ list }) => {
  return (
    <ul className={styles['list']}>
      {list.map((text, index) => (
        <li key={index} className={styles['item']}>
          <UIText2 color="gray60_100">{text}</UIText2>
        </li>
      ))}
    </ul>
  );
};
